import session_skey from './session/skey'
import cookies from './cookies'

/**
 * 检查登录态
 */
export default function (disableLoginUinFlagCheck) {
  if ((typeof LOGIN_UIN !== 'undefined' && LOGIN_UIN || disableLoginUinFlagCheck) && cookies.get('uin').substr(1) * 1 && cookies.get('skey')) {
    return new session_skey({
      uin: cookies.get('uin').substr(1) * 1,
      skey: cookies.get('skey')
    });
  }
  return false;
}
